import { render, staticRenderFns } from "./CRMManagerResetup.vue?vue&type=template&id=678ea38d&scoped=true&"
import script from "./CRMManagerResetup.vue?vue&type=script&lang=js&"
export * from "./CRMManagerResetup.vue?vue&type=script&lang=js&"
import style0 from "./CRMManagerResetup.vue?vue&type=style&index=0&id=678ea38d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678ea38d",
  null
  
)

export default component.exports